import React from 'react';
import {
  Phone, Bot, Database, Link2, FileText, Clock, History,
} from 'lucide-react';

export const AGENT_TABS = [
  { id: 'details', label: 'Assistant Details', icon: Bot },
  { id: 'call', label: 'Call Configuration', icon: Phone },
  { id: 'knowledge', label: 'Knowledge Base', icon: Database },
  { id: 'integrations', label: 'Integrations', icon: Link2 },
  { id: 'postcall', label: 'Post-Call', icon: FileText },
  { id: 'calls', label: 'Recent Calls', icon: Clock },
  { id: 'history', label: 'Version History', icon: History },
];

export const AgentTabsNav = ({ activeTab, setActiveTab }) => (
  <div className="bg-[#0d1117] border-b border-gray-800 px-6">
    <div className="flex gap-1">
      {AGENT_TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-b-2 ${
            activeTab === tab.id
              ? 'text-teal-400 border-teal-400'
              : 'text-gray-400 border-transparent hover:text-gray-200'
          }`}
          data-testid={`tab-${tab.id}`}
        >
          <tab.icon className="w-4 h-4" />
          {tab.label}
        </button>
      ))}
    </div>
  </div>
);
